/* Navigation is a content-fit decision, not a device-width breakpoint. */
(function () {
  var headers = new Map();

  function attach(header) {
    if (headers.has(header)) return;
    var slot = header.querySelector('[data-aob-navigation-slot]');
    var list = header.querySelector('[data-aob-navigation-list]');
    var toggle = header.querySelector('[data-menu-drawer-toggle]');
    if (!slot || !list || !toggle) return;
    var frame;

    function measure() {
      // The hidden list retains its intrinsic width, and its parent always
      // retains the allocated grid width, so both states measure identically.
      var available = slot.parentElement.getBoundingClientRect().width;
      var required = list.getBoundingClientRect().width;
      var expanded = required > 0 && required + 1 <= available;
      var next = expanded ? 'expanded' : 'collapsed';
      if (header.dataset.aobNavigation === next) return;
      var active = document.activeElement;
      header.dataset.aobNavigation = next;
      slot.inert = !expanded;
      slot.setAttribute('aria-hidden', String(!expanded));
      if (!expanded) {
        header.dispatchEvent(new CustomEvent('aob:header:collapse'));
        if (slot.contains(active)) toggle.focus({ preventScroll: true });
      } else if (active === toggle) {
        var first = list.querySelector('a[href], button');
        if (first) first.focus({ preventScroll: true });
      }
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(function () {
        frame = null;
        measure();
      });
    }

    function restoreFocusAfterDrawer() {
      // Resizing with the drawer open may hide the button that Alpine saved
      // as its return target. Recover only when focus has no visible target.
      if (header.dataset.aobNavigation !== 'expanded') return;
      var active = document.activeElement;
      if (active === document.body || active === toggle || active.closest('#left-drawer-slot')) {
        var first = list.querySelector('a[href], button');
        if (first) first.focus({ preventScroll: true });
      }
    }

    // ResizeObserver runs before paint; collapse in that callback so a font
    // swap or a narrowing container cannot paint overlapping navigation.
    var resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (resize) {
      resize.observe(slot.parentElement);
      resize.observe(list);
      resize.observe(header);
    }
    var mutation = new MutationObserver(schedule);
    mutation.observe(list, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule);
    document.body.addEventListener('nav-is-closed', restoreFocusAfterDrawer);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    measure();
    headers.set(header, function () {
      cancelAnimationFrame(frame);
      if (resize) resize.disconnect();
      mutation.disconnect();
      window.removeEventListener('resize', schedule);
      document.body.removeEventListener('nav-is-closed', restoreFocusAfterDrawer);
      if (document.fonts) document.fonts.removeEventListener('loadingdone', schedule);
      headers.delete(header);
    });
  }

  function init(root) {
    if (root.matches && root.matches('[data-aob-header-layout]')) attach(root);
    root.querySelectorAll('[data-aob-header-layout]').forEach(attach);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    headers.forEach(function (cleanup, header) {
      if (event.target.contains(header)) cleanup();
    });
  });
}());
